import React from 'react';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { closingPackageItemStateMeta } from '../../../../utils/closingPackageUi';
import { buildSendScansDocumentRows, type SendScansDocumentRow } from '../../lib/sendScansScanRows';
import type { ClosingPackageProjection } from '../../types';

export type ClosingPackageScanDocumentsTableProps = {
  projection: ClosingPackageProjection;
};

const ClosingPackageScanDocumentsTable: React.FC<ClosingPackageScanDocumentsTableProps> = ({
  projection,
}) => {
  const rows = buildSendScansDocumentRows(projection);

  const columns: ColumnsType<SendScansDocumentRow> = [
    {
      title: 'Документ',
      dataIndex: 'documentLabel',
      key: 'documentLabel',
    },
    {
      title: 'Файл',
      key: 'hasScan',
      render: (_, row) => (row.hasScan ? row.fileName ?? 'Есть' : 'Нет скана'),
    },
    {
      title: 'Статус',
      key: 'state',
      render: (_, row) => {
        const meta = closingPackageItemStateMeta(row.state);
        return <Tag color={meta.color}>{meta.label}</Tag>;
      },
    },
    {
      title: 'Готов к отправке',
      key: 'readyToSend',
      render: (_, row) => (
        <Tag color={row.readyToSend ? 'green' : 'default'}>
          {row.readyToSend ? 'Да' : 'Нет'}
        </Tag>
      ),
    },
  ];

  return (
    <Table
      size="small"
      rowKey="rowKey"
      pagination={false}
      dataSource={rows}
      columns={columns}
      data-testid="send-scans-documents-table"
    />
  );
};

export default ClosingPackageScanDocumentsTable;
